<!--
 * @FileDesc: 忘记密码
 * @Author: stg
 * @Date: 2025-08-20 17:44:23
 * @LastEditors: situgen@szkingdom.com
 * @LastEditTime: 2025-08-20 17:50:11
-->
<template>
    <div class="bizcomp-resetl-pwd">
        <pwdRecovery />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import pwdRecovery from "@/components/acctInfo/pwdRecovery.vue";
export default {
    name: "Resetlpwd",
    components: {
        pwdRecovery
    },
    mixins: [mixin],
    data() {
        return {
            way: "login"
        };
    },
    methods: {
        // 账户绑定选项处理
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-resetl-pwd {
    margin-top: 20px;
}
</style>
